import { render, staticRenderFns } from "./MenuSucursal.vue?vue&type=template&id=8afb110e&scoped=true"
import script from "./MenuSucursal.vue?vue&type=script&lang=js"
export * from "./MenuSucursal.vue?vue&type=script&lang=js"
import style0 from "./MenuSucursal.vue?vue&type=style&index=0&id=8afb110e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afb110e",
  null
  
)

export default component.exports